import {
  CELL_BORDER, amountFormat, createWorkbook, downloadWorkbook, styleHeaderRow,
} from '@/excel'

/**
 * Builds and downloads an .xlsx of a recipe with all its elements.
 * @param model           recipe {id, name, description}
 * @param items           recipe elements (flattened by the Recipe store)
 * @param getMeasurement  Measurement store getter (id -> {name})
 */
export async function exportRecipe({model, items, getMeasurement}) {
  const workbook = await createWorkbook()
  const sheet = workbook.addWorksheet('Рецепт', {views: [{showGridLines: false}]})
  sheet.columns = [
    {width: 6},
    {width: 45},
    {width: 14},
    {width: 10},
  ]

  sheet.addRow([`Рецепт #${model.id}`]).font = {bold: true, size: 14}
  sheet.addRow([])

  ;[['Название', model.name], ['Описание', model.description]].forEach(([label, value]) => {
    const row = sheet.addRow([label, value || ''])
    row.getCell(1).font = {bold: true}
  })

  sheet.addRow([])
  sheet.addRow([`Элементы (${items.length})`]).font = {bold: true, size: 12}
  styleHeaderRow(sheet.addRow(['#', 'Материал', 'Кол-во', 'Ед изм']))

  items.forEach((item, index) => {
    const row = sheet.addRow([
      index + 1,
      item.raw_material_name,
      item.amount,
      (getMeasurement(item.raw_material_measurement) || {}).name || '',
    ])
    row.getCell(1).alignment = {horizontal: 'center'}
    row.getCell(3).numFmt = amountFormat(item.amount)
    row.eachCell({includeEmpty: true}, cell => cell.border = CELL_BORDER)
  })

  await downloadWorkbook(workbook, `Рецепт ${model.id} ${model.name || ''}.xlsx`.replace(/\s+\.xlsx$/, '.xlsx'))
}
